import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
import SocialIcons from '../../components/footer/SocialIcons';
import Section from './Section';
import SectionItem from './SectionItem';

var getBrandLink = function getBrandLink(Link) {
  return styled(Link).withConfig({
    displayName: "SitePreFooter",
    componentId: "qy77ku-0"
  })(["text-decoration:none;color:inherit;&:hover{text-decoration:underline;}"]);
};

var ListInline = styled.ul.withConfig({
  displayName: "SitePreFooter__ListInline",
  componentId: "qy77ku-1"
})(["margin:0;list-style-type:none;> li{display:inline-block;margin-bottom:0;margin-right:", "px;&:last-child{margin-right:0;}}"], spacing.base * 2);

var SitePreFooter = function SitePreFooter(_ref) {
  var Link = _ref.Link,
      links = _ref.links;
  var BrandLink = getBrandLink(Link);
  return React.createElement(Section, null, React.createElement(SectionItem, null, React.createElement(SocialIcons, {
    Link: Link
  })), React.createElement(SectionItem, {
    alignRight: true
  }, React.createElement(ListInline, null, links.map(function (link) {
    return React.createElement("li", {
      key: link.name
    }, React.createElement(BrandLink, _extends({
      href: link.href
    }, link.props), link.name));
  }))));
};

export default SitePreFooter;